module.exports = __webpack_public_path__ + "img/3759b65.jpg";